<template>
  <div class="leftNav">
    <el-menu :default-active="activeMenu" class="el-menu-vertical-demo" :collapse="isCollapse" router
             :unique-opened="true"
             background-color="#ffffff" text-color="#404040" active-text-color="rgb(6, 32, 35)"
             :collapse-transition="false">
      <div class="header">
        <div style="display: flex;flex-direction: row-reverse;" :style="isCollapse?'margin: 15px 20px 15px 0px ':'margin: 15px 0px '">
          <el-tooltip content="折叠菜单栏" v-if="!isCollapse">
            <i class="el-icon-s-fold foldIcon" @click="changeLeftNav()"></i>
          </el-tooltip>
          <el-tooltip content="展开菜单栏" v-else>
            <i class="el-icon-s-unfold foldIcon" @click="changeLeftNav()"></i>
          </el-tooltip>
        </div>

      </div>
      <sidebar-item v-for="submenu in leftMenus"
                    :key="submenu.path+submenu.title"
                    :isCollapse="isCollapse"
                    :submenu="submenu">
      </sidebar-item>
    </el-menu>
  </div>
</template>

<script>

import {getDataInLocalStorage} from "@/utils/localStorage";
import {isNakedApprover} from "@/api/naked/user";
import SidebarItem from "@/components/leftNav/SidebarItem";
import {leftNavData, needRedDoltInfo} from "@/utils/data/basicData/leftNavData";

export default {
  name: "LeftNav",
  components: {
    SidebarItem
  },
  data() {
    return {
      isCollapse: false,
      leftMenus: leftNavData,
    };
  },
  computed: {
    // showLeftMenu() {
    //   return this.$store.getters['dataStatus/getShowLeftMenu']
    // },
    activeMenu() {
      const route = this.$route;
      const {meta, path} = {...route};
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
  },
  created() {
    this.$store.commit('dataStatus/setShowLeftMenu','setShowLeftMenu')
    this.getRedDotNum()
  },
  methods: {

    // 获取红点数量
    getRedDotNum() {
      needRedDoltInfo.forEach(item => {
        this.$store.dispatch(`dataStatus/getRedDoltNum`, item)
      })
    },
    changeLeftNav() {
      this.isCollapse = !this.isCollapse
      this.$store.commit('dataStatus/setShowLeftMenu',this.isCollapse)

    },
  }
}
</script>

<style scoped>
.leftNav {
  /*overflow-y: hidden;*/
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  height: calc(100vh - 65px);
}

.foldIcon {
  font-size: 23px;
  color: #b4b5b6;
  cursor: pointer;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width:215px;
  height: 100%;
  overflow-y: auto;
  //height: calc(100vh - 65px);
  background-color: white;
}

/deep/ .el-menu--collapse .el-submenu .el-submenu__title span {
  visibility: hidden !important;
}
/deep/ .el-menu {
  height: 100% !important;
  background-color: #ffffff !important;
}

/deep/ .el-menu-item span {
  white-space: normal;
  word-break: break-all;
  line-height: 20px;
}
/deep/ .el-submenu__title span {
  white-space: normal;
  word-break: break-all;
  line-height: 20px;
}

/deep/ .el-menu-item.is-active {
  background-color: rgb(95, 193, 201) !important;
  font-weight: 550;
  color: #ffffff !important;
}

/deep/ .el-menu-item.is-active .el-badge__content {
  font-weight: normal !important;
}

/deep/ .el-menu-item:hover {
  background: rgb(226, 247, 248) !important;
}

/deep/ .el-menu-item.is-active:hover {
  background-color: rgb(95, 193, 201) !important;
}

/deep/ .el-submenu__title:hover {
  background: rgb(226, 247, 248) !important;
}

/deep/ .el-submenu .el-menu-item{
  min-width: 150px!important;
}

/deep/  .el-menu-item {
  display: flex !important;
  align-items: center !important;
  padding:0 10px!important;
}
/deep/ .hasSonMenu .el-menu-item {
  padding-left: 25px !important;
}

/deep/  .el-submenu__title {
  display: flex !important;
  align-items: center !important;
  padding:0 10px!important;
}


</style>
